export enum TransfersAttributes {
    CustomSegmentId = 1,
    ZipPassword = 2,
    CustomSegmentDescription = 3,
    AudienceExternalIdentifier = 4,
    AudienceExternalName = 5,
    ProfileExternalIdentifier = 6,
    AdvertiserExternalIdentifier = 7,
    AudienceExternalCategoryName = 8,
    AudienceSharedAccounts = 9,
    FirstPartyData = 10,
    PercentOfMediaCostRate = 11,
    CPMRateAmount = 12,
    AudienceExternalSubType = 13,
    DatasetId = 14,
    BacthId = 15
}